module.exports = __webpack_public_path__ + "assets/img/kv-06fc820b.jpg";